export default "__VITE_ASSET__Da4uWitg__"